module.exports = __webpack_public_path__ + "static/media/banner.a731a0ce.png";